// Subtitles chosen on the /upload page which should be applied to the audio
// file being uploaded alongside them. They're handed to the /audioUploaded
// page rather than sent with the audio itself, so that both SRT workflows
// converge on the same `POST /api/processAudio` call. Kept in sessionStorage
// until the audio is saved, so a reload of /audioUploaded doesn't lose them
// and leave the user paying for a transcription they opted out of. Every
// audio upload clears the stash first, so an abandoned one can't attach
// itself to the next audio file.

const storageKey = "pendingSubtitles";

export interface PendingSubtitles {
  srtTranscript: string;
  srtFilename?: string;
}

export const clear = () => sessionStorage.removeItem(storageKey);

export const stash = (srtTranscript: string, srtFilename?: string) => {
  sessionStorage.setItem(
    storageKey,
    JSON.stringify({ srtTranscript, srtFilename })
  );
};

export const read = (): PendingSubtitles | undefined => {
  const stored = sessionStorage.getItem(storageKey);
  if (!stored) {
    return undefined;
  }
  try {
    return JSON.parse(stored);
  } catch {
    clear();
    return undefined;
  }
};
